/* unplugin-vue-components disabled */import script from "./Navbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navbar.vue?vue&type=script&lang=ts&setup=true"

import "./Navbar.vue?vue&type=style&index=0&id=317e5273&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317e5273"]])

export default __exports__